import { loadImage } from '../loaders';
import { assetUrl } from '../assets';
import { Store, markers } from './stores';

function clearNode(node: Node) {
    while (node.childNodes.length > 0) {
        node.removeChild(node.firstChild!);
    }
}

export async function init(container: Element) {
    const hidePastLocations = false;
    const intro = container.querySelector<HTMLElement>('.js-intro')!;
    const results = container.querySelector<HTMLElement>('.js-results')!;
    const map = container.querySelector('.js-map')!;
    const mapBackground = container.querySelector<HTMLImageElement>('.js-map-background')!;
    const locations = container.querySelector<HTMLUListElement>('.js-locations')!;

    function showLocations(stores: Store[]) {
        intro.hidden = true;
        results.hidden = false;

        clearNode(locations);

        locations.appendChild(createResults(stores));
    }

    await loadImage(mapBackground.src);

    markers.filter(({ stores }) => {
        if (!hidePastLocations) {
            return true;
        }

        return stores.every(store => {
            return store.date >= new Date();
        });
    }).forEach(marker => {
        const [x, y] = marker.position;
        const button = createMarker();
        button.style.left = `${(x / mapBackground.naturalWidth) * 100}%`;
        button.style.top = `${(y / mapBackground.naturalHeight) * 100}%`;
        button.addEventListener('click', () => {
            showLocations(marker.stores);
        });

        map.appendChild(button);
    });
}

function createMarker(): HTMLButtonElement {
    const icon = createMarkerIcon();
    icon.classList.add('icon', 'icon--marker', 'pickle-post-map__marker');

    const button = document.createElement('button');
    button.type = 'button';
    button.classList.add('pickle-post-map__button');
    button.appendChild(icon);

    return button;
}

function createResults(stores: Store[]): Node {
    const fragment = document.createDocumentFragment();

    stores.forEach(store => {
        fragment.appendChild(createResult(store));
    });

    return fragment;
}

function createMarkerIcon(): Element {
    const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', assetUrl('images/pickle-post/marker.svg#marker'));

    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.appendChild(use);
    icon.classList.add('icon', 'icon--marker');

    return icon;
}

function createResult(store: Store): Element {
    const icon = createMarkerIcon();
    icon.classList.add('icon', 'icon--marker', 'pickle-post-results__icon');

    const title = document.createElement('div');
    title.appendChild(document.createTextNode(`${store.name}, ${store.postcode.replace(' ', '\xa0')}`));
    title.classList.add('pickle-post-results__title');

    const date = document.createElement('div');
    date.textContent = `Date in store: ${formatDate(store.date)}`;
    date.classList.add('pickle-post-results__meta');

    const info = document.createElement('div');
    info.appendChild(title);
    info.appendChild(date);
    info.classList.add('pickle-post-results__info');

    const li = document.createElement('li');
    li.appendChild(icon);
    li.appendChild(info);
    li.classList.add('pickle-post-results__item');

    return li;
}

function formatDate(date: Date) {
    return date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });
}
